if (typeof BackToTopButton !== "function") {
	class BackToTopButton extends HTMLElement {
		constructor() {
			super();

			this.classes = {
				show: "show",
				hidden: "hidden",
			};

			this.selectors = {};

			this.elements = {};

			this.init();
		}

		init() {
			this.className = "back-to-top";

			// Add click event to scroll to the top
			this.onclick = () =>
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});

			// Add scroll event listener to toggle visibility
			window.addEventListener("scroll", this.toggleVisibility.bind(this));
		}

		toggleVisibility() {
			if (window.scrollY > window.innerHeight) {
				this.classList.add(this.classes.show);
			} else {
				this.classList.remove(this.classes.show);
			}
		}

		// connectedCallback() {}
	}

	customElements.define("back-to-top-button", BackToTopButton);
}
